import React from 'react';
import classNames from 'classnames';

import { Currency, FillUser } from '@/icons/index';
import Arrow from '@/icons/Arrow';

import ActiveLink from '../ActiveLink/ActiveLink';

import styles from './styles.module.scss';

const PhoneNumbersDropDown = ({ isBusiness }) => {
  const [active, setActive] = React.useState(false);

  return (
    <div
      className={classNames([
        styles.container,
        { [styles.active]: active, [styles.business]: isBusiness },
      ])}
      itemScope
      itemType='https://schema.org/Property'
      data-testid='dropdown-container'
    >
      <div className={styles.wrapper} onClick={() => setActive(!active)}>
        <div className={styles.left}>
          <div className={styles.user}>
            <FillUser />
          </div>
          <div className={styles.content}>
            <span>+994 555 55 55</span>
            <div className={styles.price}>
              <span>15</span> <Currency className={styles.svgCurrency} />
            </div>
          </div>
        </div>
        <Arrow className={styles.svg} />
      </div>
      <div className={styles.listWrapper}>
        <ul className={styles.list}>
          <li>
            <ActiveLink href={'/cabinet'}>
              <a>My bakcell</a>
            </ActiveLink>
          </li>
          <li>
            <ActiveLink href={'/services/my-card'}>
              <a>My cart (0)</a>
            </ActiveLink>
          </li>
          <li>
            <button aria-label='Sign out' className={styles.signOut}>
              Sign out
            </button>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default PhoneNumbersDropDown;
